import { useMutation, useQueryClient } from 'react-query'
import { ConfirmTicketDecisionRequest } from 'lib/generated/api'
import { useApiClient } from 'contexts/ApiClientContext'
import { useAuth } from 'auth'
import { useHandleApiError, delay } from 'api/utils'

export const QUERY_KEYS = {
  permissionTicket: 'permissionTicket',
} as const

export const useConfirmPermissionTicket = () => {
  const { permissionTicketApi } = useApiClient()
  const { updateToken } = useAuth()
  const queryClient = useQueryClient()
  const onError = useHandleApiError({ showMessage: false })

  queryClient.setMutationDefaults('confirmTicketDecision', {
    mutationFn: (request: ConfirmTicketDecisionRequest) =>
      permissionTicketApi.confirmTicketDecision(request),
    onError,
    onSuccess: () =>
      updateToken(-1)
        // Delay to give the client time to use the new token
        // TODO: Get rid of the delay please :(
        .then(() => delay(1000)),
  })

  return useMutation<void, unknown, ConfirmTicketDecisionRequest>(
    'confirmTicketDecision'
  )
}
